import { render, staticRenderFns } from "./SalesOrders.vue?vue&type=template&id=4554ee9c&scoped=true&"
import script from "./SalesOrders.vue?vue&type=script&lang=js&"
export * from "./SalesOrders.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrders.vue?vue&type=style&index=0&id=4554ee9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4554ee9c",
  null
  
)

export default component.exports